// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__error[data-v-28ae7c2d]{color:#54371e;background-color:#faf3ed;padding:.5rem 2rem;border-radius:10.4px;font-size:1rem;gap:10px;font-weight:500}.text_feedback[data-v-28ae7c2d]{width:100%;margin-top:.5rem;font-size:80%;color:#f83245}li.text__note--list[data-v-28ae7c2d]{list-style-type:disc;margin:.5rem 0}", ""]);
// Exports
module.exports = exports;
